import { useTranslation } from 'react-i18next';
import { IonButton, IonIcon, IonText } from '@ionic/react';
import { close, pricetagOutline } from 'ionicons/icons';
import classNames from 'classnames';

import { useCartPriceGetter } from 'src/hooks';
import { useDispatch, useSelector } from 'src/store';
import { removeVoucher } from 'src/slices/cart';
import { formatPrice } from 'src/utils';
import classes from './TotalPrice.module.scss';
import textClasses from 'src/styles/text.module.scss';

const TotalPrice: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { total, subtotal, voucherDiscount } = useCartPriceGetter();
  const { appliedVoucher } = useSelector((state) => state.cart);

  const hasVoucherDiscount = voucherDiscount > 0;

  return (
    <div className={classes.container}>
      {hasVoucherDiscount && (
        <div className={classes.breakdown}>
          <div className={classes.subtotalRow}>
            <span className={classes.subtotalLabel}>{t('Subtotal')}</span>
            <span className={classes.subtotalValue}>{formatPrice(subtotal)}</span>
          </div>
          <div className={classes.discountRow}>
            <span className={classes.discountLabel}>
              <IonIcon icon={pricetagOutline} className={classes.voucherIcon} />
              {appliedVoucher?.code || t('Voucher discount')}
            </span>
            <div className={classes.discountRight}>
              <span className={classes.discountValue}>-{formatPrice(voucherDiscount)}</span>
              {appliedVoucher && (
                <IonButton
                  fill="clear"
                  size="small"
                  onClick={() => dispatch(removeVoucher())}
                  className={classes.removeBtn}
                >
                  <IonIcon icon={close} className={classes.removeIcon} />
                </IonButton>
              )}
            </div>
          </div>
        </div>
      )}

      <div className={classes.totalRow}>
        <h2 className={classNames(textClasses.titleBold, classes.label)}>{t('Total')}</h2>
        <IonText className={classNames(textClasses.title, classes.value)} color="primary">
          {formatPrice(total)}
        </IonText>
      </div>
    </div>
  );
};

export default TotalPrice;
